import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { ChooseplanPage } from './chooseplan.page';

const routes: Routes = [
  {
    path: '',
    component: ChooseplanPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ChooseplanPageRoutingModule {}
